export class IntegratedFtpCreateContainer {
    PartnerId: number;
    Username: string;
    Password: string;
    SubDirectories: string[];
    ExcludeFromIntegratedFtpRetrieve: boolean;
    FileIdentifier: string;
}
